import React, { useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField
} from '@mui/material';

/**
 * Supplier Information Component for Purchase Returns
 */
const SupplierInformation = ({
  purchaseReturn,
  controlStyle,
  suppliers = [],
  onPurchaseReturnChange
}) => {
  useEffect(() => {
    console.log('SupplierInformation: purchaseReturn changed', purchaseReturn);
    if (purchaseReturn && purchaseReturn.supplier) {
      console.log('SupplierInformation: supplier data received', purchaseReturn.supplier);
    }
  }, [purchaseReturn]);

  const supplier = purchaseReturn?.supplier || {};

  const formatAddress = (addr) => {
    if (!addr) return '';
    if (typeof addr === 'string') return addr;

    if (typeof addr === 'object') {
      const parts = [
        addr.street,
        addr.shortAddress,
        addr.city,
        addr.state,
        addr.country,
        addr.postalCode
      ].filter(part => part && String(part).trim() !== '');
      return parts.join(', ');
    }

    return String(addr);
  };

  const displayAddress = formatAddress(supplier.address || supplier.customerAddress);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 0.5,
        mb: 0.5,
        borderRadius: '4px',
        boxShadow: 'none',
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.02)',
        },
      }}
    >
      <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 0.5, fontSize: '0.875rem' }}>
        Supplier Information
      </Typography>
      <Grid container spacing={0.5}>
        <Grid item xs={12}>
          <TextField
            label="Supplier Name"
            value={supplier.name || supplier.customerName || ''}
            fullWidth
            margin="dense"
            size="small"
            inputProps={{
              readOnly: true,
            }}
            sx={{
              ...controlStyle,
              '& .MuiOutlinedInput-root': {
                borderRadius: 0,
                height: 36,
                cursor: 'not-allowed',
              },
              '& .MuiOutlinedInput-input': {
                cursor: 'not-allowed',
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {supplier.vat || supplier.vatNumber ? (
            <TextField
              label="VAT Number"
              value={supplier.vat || supplier.vatNumber || ''}
              fullWidth
              margin="dense"
              size="small"
              inputProps={{
                readOnly: true,
              }}
              sx={{
                ...controlStyle,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                  height: 36,
                  cursor: 'not-allowed',
                },
                '& .MuiOutlinedInput-input': {
                  cursor: 'not-allowed',
                },
              }}
            />
          ) : (
            <TextField
              label="Phone Number"
              value={supplier.phone || supplier.customerPhone || ''}
              fullWidth
              margin="dense"
              size="small"
              inputProps={{
                readOnly: true,
              }}
              sx={{
                ...controlStyle,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                  height: 36,
                  cursor: 'not-allowed',
                },
                '& .MuiOutlinedInput-input': {
                  cursor: 'not-allowed',
                },
              }}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Address"
            value={displayAddress}
            fullWidth
            multiline
            rows={2.5}
            margin="dense"
            size="small"
            inputProps={{
              readOnly: true,
            }}
            sx={{
              ...controlStyle,
              '& .MuiOutlinedInput-root': {
                minHeight: 70,
                borderRadius: 0,
                cursor: 'not-allowed',
              },
              '& .MuiOutlinedInput-input': {
                cursor: 'not-allowed',
              },
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SupplierInformation;
